var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mainShow)?_c('main-reconciliation',{on:{"mainClick":_vm.handleClick}}):_vm._e(),(_vm.detailShow)?_c('detail-reconciliation',{attrs:{"mainInfo":_vm.mainInfo,"factoryList":_vm.factoryList,"accList":_vm.accList},on:{"detailClick":_vm.handleDetailClick}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }